// This loads jQuery (automatically found in /node_modules/jquery)
import $ from 'jquery';

function dataWord ()
{
  // Init vars  & wordlist from HTML
  var $words  = $("[data-words]").attr("data-words").split("|"),
	  $switch = $("[data-words]").parent(".switch"),
	  $i      = 0,
	  $total  = $words.length;

  // Init
  $("[data-words]").html($words[$i]);
  $switch.css("width", $("[data-words]").width() + "px" );

  // Swap out words every so often
  function swap()
  {
	// Hide current words
	$switch.addClass("animating").delay(500).queue(function()
	{
	  // Update words with the next set in the array
	  $("[data-words]").html($words[$i]);

	  // Update the width of the container accordingly
	  $switch.css("width", $("[data-words]").width() + "px" ).delay(500).queue(function()
	  {
		// Unhide the new words
		$switch.removeClass("animating").dequeue();
	  }).dequeue();
	});

	// Advance the word list pointer
	($i < $total-1) ? $i++ : $i = 0;
  }

  // Run the word swap function every 5 seconds
  setInterval(swap, 5000);
}

$(document).ready(function()
{
	if ( $('[data-words]').length > 0 )
	{
		// console.log('There is a [data-words] element');
		dataWord();

		$(window).resize(function()
		{
		  $("[data-words]").parent(".switch").css("width", $("[data-words]").width() + "px" );
		});
	}
});